import React from "react";
import MainContainer from "src/features/home/Home";
import projectOptions from "./shared/project-options";

function App() {
  console.info(
    "Live Commerce App loaded with the config:",
    projectOptions.default
  );
  return (
    <div>
      <MainContainer />
      <div id="react-portal-container"></div>
    </div>
  );
}

export default App;
